export interface ModalProps {
  closeModal: () => void;
  className?: string;
  modalSize: ModalSizeType;
  renderOutsideModalCard?: React.ReactNode;
  showCloseIcon?: boolean;
}

export enum ModalSizeType {
  SMALL = "sm",
  MEDIUM = "md",
  LARGE = "lg",
}
